"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.restoreSanitizedValue = exports.sanitizeAllButStyling = exports.sanatizeUrl = exports.sanitizeStyleAttribute = exports.sanitizeStyleTags = exports.sanitizeScriptTags = exports.sanitizeEventAttributes = exports.htmlDecode = exports.htmlEncode = exports.sanitizeUnwantedElements = exports.cleanupMarkup = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

// eslint-disable-next-line
var UNSAFE_CHARS_REGEXP = /[<>\/\u2028\u2029]/g; // Map characters for being sanatized.

var ESCAPED_CHARS = {
  '<': '&lt;',
  '>': '&gt;',
  '/': '&#47;',
  "\u2028": "\\u2028",
  "\u2029": "\\u2029"
};
var ESCAPED_CHARS_MINI = {
  '<': '&lt'
}; // For urls

var LINK_INVALID_CHARACTERS = {
  '<': '',
  '>': '',
  '{': '',
  '}': '',
  '(': '',
  ')': ''
};

var sanitizeUrlCharacters = function sanitizeUrlCharacters(unsafeChar) {
  return LINK_INVALID_CHARACTERS[unsafeChar];
}; // For tags


var SCRIPT = '<script';
var UNSAFE_SCRIPT = '<unsafe_script';
var STYLE = '<style';
var UNSAFE_STYLE = '<unsafe_style'; // These event attributes are sanitized from all elements by default.

var BAD_ATTRIBUTES = ['onclick', 'onfocus', 'onload', 'onafterprint', 'onbeforeprint', 'onbeforeunload', 'onerror', 'onhashchange', 'onmessage', 'onoffline', 'ononline', 'onemptied', 'onpageshow', 'onpopstate', 'onresize', 'onstorage', 'onunload', 'onkeydown', 'onkeypress', 'onkeyup', 'onclick', 'ondblclick', 'oncontextmenu', 'ondrag', 'ondragend', 'ondragenter', 'ondragleave', 'ondragover', 'ondragstart', 'ondrop', 'onmousedown', 'onmousemove', 'onmouseout', 'onmouseover', 'onmouseup', 'onmousewheel', 'onscroll', 'onshow', 'ontoggle', 'onwheel', 'onseeking', 'onratechange', 'ontoggle', 'onvolumechange', 'onsuspend', 'onwaiting'];
var SUPPORTED_ELEMENTS = ['div', 'span', 'p', 'b', 'i', 'u', 'strong', 'em', 'ul', 'li', 'ol', 'hr', 'br', 'button', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'a', 'img', 'picture', 'figure', 'svg', 'video', 's', 'iframe', 'caption', 'source', 'figcaption', 'sup', 'sub', 'small', 'del', 'blockquote', 'q', 'time', 'center', 'pre', 'table', 'td', 'tr', 'thead', 'tbody', 'tfoot'];

var escapeUnsafeChars = function escapeUnsafeChars(unsafeChar) {
  return ESCAPED_CHARS[unsafeChar];
};

var escapeUnsafeCharsMini = function escapeUnsafeCharsMini(unsafeChar) {
  return ESCAPED_CHARS_MINI[unsafeChar];
}; // Helper function for validating the DOM markup and correcting it


var cleanupMarkup = function cleanupMarkup(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var getText = options.getText;

  if (value && value.length && document && document.createElement) {
    var wrapper = document.createElement('div');

    if (getText) {
      wrapper.innerText = value;
      return wrapper.innerHTML;
    }

    wrapper.innerHTML = value; // We return the string DOM validated

    return wrapper.innerHTML;
  }

  return value;
}; // Helper function for validating the input and converting it to a string.


exports.cleanupMarkup = cleanupMarkup;

var getValue = function getValue(value) {
  var newValue = value;

  if (newValue && newValue.length) {
    if ((0, _typeof2["default"])(newValue) === 'object') {
      // Make sure we stringify for other object cases
      newValue = JSON.stringify(newValue);
    }
  }

  return newValue;
}; // Helper functions to help reduce false positives


var sanitizeUnwantedElements = function sanitizeUnwantedElements(value) {
  var newValue = getValue(value);

  if (newValue && newValue.length) {
    newValue = newValue.replace(/[<]/g, escapeUnsafeCharsMini);
    SUPPORTED_ELEMENTS.forEach(function (element) {
      var elementMatchString = '&lt' + element;
      var elementMatchCloseString = '&lt/' + element;
      newValue = newValue.replace(new RegExp(elementMatchString, 'gim'), '<' + element);
      newValue = newValue.replace(new RegExp(elementMatchCloseString, 'gim'), '</' + element);
    });
    return newValue;
  }
}; // Exported function for simply encoding the whole string


exports.sanitizeUnwantedElements = sanitizeUnwantedElements;

var htmlEncode = function htmlEncode(value) {
  var newValue = getValue(value);

  if (newValue && newValue.length) {
    newValue = newValue.replace(UNSAFE_CHARS_REGEXP, escapeUnsafeChars);
  }

  return newValue;
}; // Exported function for simply reverses the encoding done above in htmlEncode


exports.htmlEncode = htmlEncode;

var htmlDecode = function htmlDecode(value) {
  var newValue = getValue(value);

  if (newValue && newValue.length) {
    newValue = newValue.replace(new RegExp('&lt;', 'gim'), '<');
    newValue = newValue.replace(new RegExp('&gt;', 'gim'), '>');
    newValue = newValue.replace(new RegExp('&#47;', 'gim'), '/');
    newValue = newValue.replace(new RegExp("\\u2028", 'gim'), "\u2028");
    newValue = newValue.replace(new RegExp("\\u2029", 'gim'), "\u2029");
  }

  return newValue;
}; // Exported function for stripping all bad attributes from an element


exports.htmlDecode = htmlDecode;

var sanitizeEventAttributes = function sanitizeEventAttributes(value) {
  var newValue = getValue(value);

  if (newValue && newValue.length) {
    BAD_ATTRIBUTES.forEach(function (badAttribute) {
      if (newValue.includes(badAttribute)) {
        // Restore the old ones.
        if (newValue.includes("data-unsafe_".concat(badAttribute))) {
          newValue = newValue.replace(new RegExp("data-unsafe_".concat(badAttribute), 'gim'), badAttribute);
        } // sanitize all cases.


        newValue = newValue.replace(new RegExp(badAttribute + '\\s*=', 'gim'), "data-unsafe_".concat(badAttribute));
      }
    });
  }

  return newValue;
}; // Exported function for stripping script tags


exports.sanitizeEventAttributes = sanitizeEventAttributes;

var sanitizeScriptTags = function sanitizeScriptTags(value) {
  var newValue = getValue(value);

  if (newValue && newValue.length && newValue.includes(SCRIPT)) {
    if (newValue.includes(UNSAFE_SCRIPT)) {
      newValue = newValue.replace(new RegExp(UNSAFE_SCRIPT, 'gim'), SCRIPT);
    }

    newValue = newValue.replace(new RegExp(SCRIPT, 'gim'), UNSAFE_SCRIPT);
  }

  return newValue;
}; // Exported function for stripping style tags


exports.sanitizeScriptTags = sanitizeScriptTags;

var sanitizeStyleTags = function sanitizeStyleTags(value) {
  var newValue = getValue(value);

  if (newValue && newValue.length && newValue.includes(STYLE)) {
    if (newValue.includes(UNSAFE_STYLE)) {
      newValue = newValue.replace(new RegExp(UNSAFE_STYLE, 'gim'), STYLE);
    }

    newValue = newValue.replace(new RegExp(STYLE, 'gim'), UNSAFE_STYLE);
  }

  return newValue;
};

exports.sanitizeStyleTags = sanitizeStyleTags;

var sanitizeStyleAttribute = function sanitizeStyleAttribute(value) {
  var newValue = getValue(value);

  if (newValue && newValue.length && newValue.includes('style')) {
    if (newValue.includes('data-unsafe_style')) {
      newValue = newValue.replace(new RegExp("data-unsafe_style", 'gim'), "style");
    }

    newValue = newValue.replace(new RegExp('style' + '\\s*=', 'gim'), "data-unsafe_style");
  }

  return newValue;
}; // Helper function for sanatizingUrls


exports.sanitizeStyleAttribute = sanitizeStyleAttribute;

var sanatizeUrl = function sanatizeUrl(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // Make sure the uris are a little decoded
  var newValue = decodeURI(decodeURIComponent(getValue(value)));

  if (newValue && newValue.length) {
    // keepSanatizedAttributes will turn unsafe javascript attributes into data attributes
    var keepSanatizedAttributes = options.keepSanatizedAttributes; // strip common illegal characters

    newValue = newValue.replace(/[<>{}()]/g, sanitizeUrlCharacters); // strip spaces

    newValue = newValue.trim(); // Sanatize illegal code from the url

    BAD_ATTRIBUTES.forEach(function (attribute) {
      if (newValue.includes(attribute)) {
        // We may want to keep a sanitized version of the value.
        var replacement = keepSanatizedAttributes ? "_".concat(attribute) : ''; // Clean the old values first.

        if (newValue.includes("_".concat(attribute))) {
          newValue = newValue.replace(new RegExp("_".concat(attribute), 'gim'), attribute);
        } // apply it in all all cases.


        newValue = newValue.replace(new RegExp(attribute, 'gim'), replacement);
      }
    }); // Sanitize potential elements being added

    newValue = cleanupMarkup(newValue, {
      getText: true
    });
  }

  return newValue;
}; // Helper functions for RTE.


exports.sanatizeUrl = sanatizeUrl;

var sanitizeAllButStyling = function sanitizeAllButStyling(value) {
  var newValue = getValue(value);

  if (newValue && newValue.length) {
    newValue = sanitizeScriptTags(newValue);
    newValue = sanitizeEventAttributes(newValue);
    newValue = sanitizeUnwantedElements(newValue);
    newValue = cleanupMarkup(newValue);
    return newValue;
  }

  return newValue;
}; // Will remove the encoded characters and _unsafe from the string.


exports.sanitizeAllButStyling = sanitizeAllButStyling;

var restoreSanitizedValue = function restoreSanitizedValue(value) {
  var newValue = getValue(value);

  if (newValue && newValue.length) {
    var elementMatchString = '&lt'; // Restore encoded character

    newValue = newValue.replace(new RegExp(elementMatchString, 'gim'), '<'); // Restore unsafe attributes

    newValue = newValue.replace(new RegExp('data-unsafe_' + '\\s*=', 'gim'), ""); // Restore unsafe elements

    newValue = newValue.replace(new RegExp('unsafe_script' + '\\s*=', 'gim'), "script");
    newValue = newValue.replace(new RegExp('unsafe_style' + '\\s*=', 'gim'), "style");
  }

  return newValue;
};

exports.restoreSanitizedValue = restoreSanitizedValue;
var _default = sanitizeAllButStyling;
exports["default"] = _default;